import { spaceCadet, chromeYellow } from '@cogneed/react-utils';
import { Box, alpha, styled } from '@mui/material';

const StyledBox = styled(Box)(({ theme }) => ({
  boxShadow: theme.shadows[3],
  backgroundColor: spaceCadet[500],
  borderRadius: 50,
  padding: '10px 16px',
  pointerEvents: 'auto',

  '& .MuiButtonBase-root': {
    backgroundColor: 'transparent',
    color: spaceCadet[100],
    '&:hover': {
      backgroundColor: alpha('#fff', 0.15),
    },
  },

  '& .MuiButtonBase-root.select': {
    padding: '4px 8px',
    borderRadius: 4,

    transition: theme.transitions.create(['background-color', 'color'], {
      duration: theme.transitions.duration.shortest,
    }),

    '& svg': {
      transform: 'rotate(0deg)',
      transition: theme.transitions.create(['transform'], {
        duration: theme.transitions.duration.shortest,
      }),
    },

    '&.expand': {
      backgroundColor: alpha('#fff', 0.3),
      '& svg': {
        transform: 'rotate(180deg)',
      },
    },
  },

  '& .MuiButton-root.exit': {
    minWidth: 0,
    fontSize: 16,
  },
  '& > .MuiBox-root': {
    backgroundColor: chromeYellow[400],
    boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.25)',
    borderRadius: '10px',
    display: 'flex',
    padding: '4px 12px',
    alignItems: 'center',

    '& .MuiTypography-root': {
      color: spaceCadet[500],
      fontWeight: 700,
      lineHeight: '16px',
      fontSize: 12,
      padding: 4,
      borderRadius: 4,
    },

    '& .MuiButton-root': {
      fontSize: 16,
      minWidth: 0,
      padding: 4,
      color: spaceCadet[500],
      '& svg': {
        fontSize: 'inherit',
      },
    },
  },
}));

export default StyledBox;
